// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback } from 'react';

import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
import type { AppId } from '../../../../../../../controllers/issue-adjustments/types';
import { getAnalytics } from '../../../../../../../controllers/view-configuration';
import type { RegisterFieldsEventPayload } from './types';

export const useRegisterFields = ({
	appId,
}: {
	appId: AppId;
}): (({ fields, changeId }: RegisterFieldsEventPayload) => Promise<void>) => {
	const { setError, registerFields } = useIssueAdjustmentsActions();
	const viewType = useViewType();

	return useCallback(
		async ({ fields, changeId }: RegisterFieldsEventPayload) => {
			try {
				// We want to register only fields that are strings.
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				const validFieldIds = fields.filter((fieldId: any) => typeof fieldId === 'string');

				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
				if ((typeof changeId as any) === 'string') {
					registerFields({ changeId, fieldsToBeRegistered: validFieldIds, appId });
				}
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				setError({
					errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE',
				});
				throw err;
			} finally {
				getAnalytics(viewType).markFieldsRegistered();
			}
		},
		[appId, registerFields, setError, viewType],
	);
};
